import { isString } from './type.helper';

export const URL_REGEX = /^(http(s)?:\/\/)(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const DATE_REGEX = /^\d{2}\.\d{2}\.\d{4}$/; // TODO: find better regex

export type MessageFunction = (entity: any) => string;

export interface IValidator {
  validatorFunc: (entity: any) => boolean;
  message?: string | MessageFunction;
}

export function isValidEmail(email: string): boolean {
  return EMAIL_REGEX.test(email);
}

export function isValidDateString(date: string): boolean {
  return DATE_REGEX.test(date);
}

export function isValidUrl(url: string): boolean {
  if (!isDefined(url) || url === '') {
    return true;
  }
  return URL_REGEX.test(url);
}

export function isValidStringWithMinLength(val: string, minLength: number): boolean {
  return val && typeof val === 'string' && val.length >= minLength;
}

export function isNumberGreaterEqualMin(val: string | number, min: number, valueRequired = false): boolean {
  if (!val && !valueRequired) {
    return true;
  }
  if (!val && valueRequired) {
    return false;
  }
  try {
    const numberVal: number = isString(val) ? parseInt(val.toString(), 10) : <number>val;
    return numberVal >= min;
  } catch (e) {
    console.error('isValidNumberGreaterEqualMin', e);
    return false;
  }
}

export function isNumberLessEqualMax(val: string | number, max: number, valueRequired = false): boolean {
  if (!val && !valueRequired) {
    return true;
  }
  if (!val && valueRequired) {
    return false;
  }
  try {
    const numberVal: number = isString(val) ? parseInt(val.toString(), 10) : <number>val;
    return numberVal <= max;
  } catch (e) {
    return false;
  }
}

export function isNull(value: any) {
  return value === null;
}

export function isDefined(value: any): boolean {
  return typeof value !== 'undefined' && !isNull(value);
}

export function isUndefined(value: any): boolean {
  return !isDefined(value);
}
